import { ReactNode } from 'react';

import useCourseChannel from './vm';

export interface CourseChannelProps {
  children: ReactNode;
}

const CourseChannel = ({ children }: CourseChannelProps) => {
  useCourseChannel();
  return <>{children}</>;
};

export default CourseChannel;
